import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { DialogProvider, ToastProvider } from '@thefarmersfront/kitchen';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from './configs/queryClient';

import App from './App';
import { IS_MOCK_ENV, enableMocking } from './mocks/enableMocking';
import reportWebVitals from './reportWebVitals';
import { registerSW } from './serviceWorkerRegister';

import './assets/styles/default.scss';

async function bootstrap() {
  await enableMocking();

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ToastProvider>
          <DialogProvider>
            <App />
          </DialogProvider>
        </ToastProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );

  if (!IS_MOCK_ENV) {
    registerSW();
  }

  reportWebVitals();
}

bootstrap();
